<template>
  <CommentForm></CommentForm>
  
  <div class="commentCount" v-if="result && result.CommentsCount > 1">
    {{result.CommentsCount}} {{ $texter.kommentarer }}
  </div>

  <div class="commentCount" v-if="result && result.CommentsCount == 1">
    {{result.CommentsCount}} {{ $texter.kommentar }}
  </div>

  <div class="commentCount" v-if="result && result.CommentsCount == 0">
    {{ $texter.forstAttKommentera }}
  </div>

  <Comment 
    v-if="result && result.Comments"
    v-for="comment in result.Comments" 
    :key="comment.Id" 
    :comment="comment"
  >
  </Comment>
</template>

<script>

import commentService from "../plugins/commentService";
import Comment from "./components/comment.vue";
import CommentForm from "./components/commentForm.vue";

export default {
  name: "Comments",
  props: {
    baseApiUrl: String,
    blockId: String,
    isAdmin: Boolean,
    csrfToken: String,
    sortering: String,
    texter: String,
  },
  data: function () {
    return {
      result: undefined,
      showLoading: false,
    };
  },
  components: {
    Comment,
    CommentForm,
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $commentService: commentService,
      $blockId: this.blockId,
      $isAdmin: this.isAdmin === "True",
      $csrfToken: this.csrfToken,
      $texter: this.texter,
      $fetchData: this.fetchData,
      $loading: this.loading,
    }

    this.$commentService.init(this.csrfToken);
    this.$fetchData();
  },
  methods: {
    async fetchData() {     
      try {
        this.isLoading = true;
        this.showLoading = true;
        this.$commentService.getComments(this.$blockId, this.sortering).then((res) => {
          this.result = res.data;
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
        this.showLoading = false;
      }
    },
    loading(value) {
      this.showLoading = value;
    },
  }
};
</script>
